export const apiConstants = {
  GetAllCourses: 'services/app/Courses/GetAll',
  GetCourse: 'services/app/Courses/Get',
};
